module.exports = __webpack_public_path__ + "img/play.f9740c69.png";